import React, { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Chip,
  Fade
} from '@mui/material';
import LoadingImage from '../../components/LoadingImage';

interface BlogPost {
  slug: string;
  title: string;
  summary: string;
  image: string;
  date: string;
  category: string;
}

const BlogList: React.FC = () => {
  useEffect(() => {
    document.title = "Blog - Kale Treyler Frigo | Mersin Dorse Servisi ve Bakım Rehberi";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', "Mersin'de frigo dorse bakımı, araç içi yalıtım techniques, double deck montajı ve dorse kasa onarım süreçleri hakkında güncel sektörel blog yazıları.");
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', "frigo dorse blog, dorse servisi Mersin, araç içi yalıtım rehberi, double deck montajı blog");
    }

    const canonicalLink = (document.querySelector('link[rel="canonical"]') || document.createElement('link')) as HTMLLinkElement;
    canonicalLink.setAttribute('rel', 'canonical');
    canonicalLink.setAttribute('href', 'https://kaletreyler.com/blog');
    if (!document.head.contains(canonicalLink)) {
      document.head.appendChild(canonicalLink);
    }
  }, []);

  const posts: BlogPost[] = [
    {
      slug: 'frigo-dorse-isi-yalitimi-1',
      title: 'Mersin\'de Frigo Dorse İzolasyonu ve Isı Kontrolü',
      summary: 'Mersin\'de frigo dorse ısı yalıtımı, poliüretan izolasyon uygulamaları ve araç içi yalıtım teknikleri.',
      image: '/25.png',
      date: '15 Temmuz 2026',
      category: 'Araç İçi Yalıtım'
    },
    {
      slug: 'frigo-dorse-isi-yalitimi-2',
      title: 'Poliüretan Köpükle Dorse Kasa İzolasyonu Yöntemleri',
      summary: 'Frigo dorse kasalarında poliüretan köpük kaplama ve araç içi yalıtımla soğuk hava koruması.',
      image: '/25.png',
      date: '14 Temmuz 2026',
      category: 'Araç İçi Yalıtım'
    },
    {
      slug: 'frigo-dorse-isi-yalitimi-3',
      title: 'Frigo Kasalarda Isı Kaybını Önlemenin Teknik Yolları',
      summary: 'Dorse kasa içi yalıtım süreçleri, panel içi köpükleme ve ısı sızıntısı giderme işlemleri.',
      image: '/25.png',
      date: '13 Temmuz 2026',
      category: 'Araç İçi Yalıtım'
    },
    {
      slug: 'frigo-dorse-isi-yalitimi-4',
      title: 'Soğuk Zincir Taşımacılığında Araç İçi Yalıtım Standartları',
      summary: 'Tır dorselerinde soğuk hava kaçaklarını önleyen poliüretan izolasyon teknik detayları.',
      image: '/25.png',
      date: '12 Temmuz 2026',
      category: 'Araç İçi Yalıtım'
    },
    {
      slug: 'frigo-dorse-isi-yalitimi-5',
      title: 'Tır Dorse Kasalarında Panel Yalıtımı ve Enerji Verimliliği',
      summary: 'Mersin Akdeniz dorse yalıtımı ile frigo kasa içi poliüretan kaplama adımları.',
      image: '/25.png',
      date: '11 Temmuz 2026',
      category: 'Araç İçi Yalıtım'
    },
    {
      slug: 'frigo-dorse-isi-yalitimi-6',
      title: 'Mersin Akdeniz Bölgesi Frigo Dorse İzolasyon İşlemleri',
      summary: 'Frigo kasa dorse panellerinin ısı yalıtım standartları ve enerji tasarrufuna etkisi.',
      image: '/25.png',
      date: '10 Temmuz 2026',
      category: 'Araç İçi Yalıtım'
    },
    {
      slug: 'frigo-dorse-isi-yalitimi-7',
      title: 'Dorselerde Poliüretan Kaplama ile Isı Yalıtımı Yapımı',
      summary: 'Soğutmalı dorse kasalarında panel onarımı ve araç içi izolasyon uygulamaları.',
      image: '/25.png',
      date: '9 Temmuz 2026',
      category: 'Araç İçi Yalıtım'
    },
    {
      slug: 'frigo-dorse-isi-yalitimi-8',
      title: 'Frigo Dorse Kasası Köprü Bölgesi Yalıtımı Neden Önemlidir?',
      summary: 'Mersin MIG tır parkı dorse izolasyonu ile ısı kaçaklarının tespiti ve tamiri.',
      image: '/25.png',
      date: '8 Temmuz 2026',
      category: 'Araç İçi Yalıtım'
    },
    {
      slug: 'frigo-dorse-isi-yalitimi-9',
      title: 'Soğutmalı Kasalarda Isı Köprülerinin Giderilmesi Yöntemleri',
      summary: 'Frigo tır dorselerinde sandviç panel yalıtım revizyonu ve poliüretan enjeksiyonu.',
      image: '/25.png',
      date: '7 Temmuz 2026',
      category: 'Araç İçi Yalıtım'
    },
    {
      slug: 'frigo-dorse-isi-yalitimi-10',
      title: 'Frigo Dorselerde Poliüretan Enjeksiyon ve Yalıtım Rehberi',
      summary: 'Dorse kasa taban ve tavan yalıtımında kullanılan kaliteli poliüretan uygulama rehberi.',
      image: '/25.png',
      date: '6 Temmuz 2026',
      category: 'Araç İçi Yalıtım'
    },
    {
      slug: 'double-deck-dorse-tasima-kapasitesi-1',
      title: 'Tır Dorselerinde Çift Kat (Double Deck) Kurulumu',
      summary: 'Mersin\'de tır dorselerinde çift kat (double deck) sistemi kurulumu ve taşıma kapasitesi artırma detayları.',
      image: '/24.jpg',
      date: '15 Temmuz 2026',
      category: 'Double Deck'
    },
    {
      slug: 'double-deck-dorse-tasima-kapasitesi-2',
      title: 'Double Deck Sistem ile Dorse Yük Hacmini Artırma',
      summary: 'Double deck çift kat dorse montajı ve lojistikte taşıma hacmini ikiye katlama yöntemleri.',
      image: '/24.jpg',
      date: '14 Temmuz 2026',
      category: 'Double Deck'
    },
    {
      slug: 'double-deck-dorse-tasima-kapasitesi-3',
      title: 'Lojistikte Verimlilik Sağlayan Çift Katlı Dorse Sistemleri',
      summary: 'Mersin dorse tadilat atölyemizde yapılan double deck montajı ve yük kapasitesi artırma adımları.',
      image: '/24.jpg',
      date: '13 Temmuz 2026',
      category: 'Double Deck'
    },
    {
      slug: 'double-deck-dorse-tasima-kapasitesi-4',
      title: 'Mersin\'de Dorse Çift Kat (Double Deck) Montaj Aşamaları',
      summary: 'Çift katlı dorse sistemleri ile hassas paletli yüklerin güvenli taşınma teknikleri.',
      image: '/24.jpg',
      date: '12 Temmuz 2026',
      category: 'Double Deck'
    },
    {
      slug: 'double-deck-dorse-tasima-kapasitesi-5',
      title: 'Double Deck Taşıma Hacmi ve Kiriş Ayarlama Sistemleri',
      summary: 'Tır dorselerinde üst yükseklik hacmini aktif kullanmayı sağlayan alüminyum kiriş montajı.',
      image: '/24.jpg',
      date: '11 Temmuz 2026',
      category: 'Double Deck'
    },
    {
      slug: 'double-deck-dorse-tasima-kapasitesi-6',
      title: 'Çift Katlı Dorse Tadilatı ve Taşıyıcı Duvar Mukavemeti',
      summary: 'Dorse yan duvarlarına zarar vermeden entegre edilen çift katlı taşıma profilleri rehberi.',
      image: '/24.jpg',
      date: '10 Temmuz 2026',
      category: 'Double Deck'
    },
    {
      slug: 'double-deck-dorse-tasima-kapasitesi-7',
      title: 'Paletli Yüklerde Taşıma Kapasitesini Artırma Yöntemleri',
      summary: 'Lojistik firmaları için sefer maliyetlerini yarıya indiren çift katlı dorse modifikasyonu.',
      image: '/24.jpg',
      date: '9 Temmuz 2026',
      category: 'Double Deck'
    },
    {
      slug: 'double-deck-dorse-tasima-kapasitesi-8',
      title: 'Dorse İçerisine Double Deck Kiriş Montajı Nasıl Yapılır?',
      summary: 'Mersin MIG tır parkı bölgesinde uygulanan dorse çift kat montajı ve mukavemet testleri.',
      image: '/24.jpg',
      date: '8 Temmuz 2026',
      category: 'Double Deck'
    },
    {
      slug: 'double-deck-dorse-tasima-kapasitesi-9',
      title: 'Hassas Yük Taşımacılığında Çift Katlı Dorse Avantajları',
      summary: 'Farklı yüksekliklerdeki paletli malzemeler için ayarlanabilir double deck dorse çözümleri.',
      image: '/24.jpg',
      date: '7 Temmuz 2026',
      category: 'Double Deck'
    },
    {
      slug: 'double-deck-dorse-tasima-kapasitesi-10',
      title: 'Tır Dorselerinde Hacim Optimizasyonu ve Çift Kat Tasarımı',
      summary: 'Tır ve dorse kasalarında taşıma kapasitesini artıran profesyonel çift kat mekanizmaları.',
      image: '/24.jpg',
      date: '6 Temmuz 2026',
      category: 'Double Deck'
    },
    {
      slug: 'frigo-dorse-kasa-tamiri-mersin-1',
      title: 'Frigo Dorse Kasası ve Panel Onarım Teknikleri',
      summary: 'Mersin\'de frigo dorse kasa onarımı, hasarlı poliüretan sandviç panel tamiri ve polyester kaplama onarımı detayları.',
      image: '/1.jpg',
      date: '15 Temmuz 2026',
      category: 'Kasa Tamiri'
    },
    {
      slug: 'frigo-dorse-kasa-tamiri-mersin-2',
      title: 'Mersin\'de Frigo Dorse Kasa ve Sandviç Panel Tamiri',
      summary: 'Frigo dorse kasa tamiri Mersin ve tır kasa paneli onarımı süreçleri hakkında teknik bilgiler.',
      image: '/1.jpg',
      date: '14 Temmuz 2026',
      category: 'Kasa Tamiri'
    },
    {
      slug: 'frigo-dorse-kasa-tamiri-mersin-3',
      title: 'Hasar Gören Dorse Panellerinde Polyester ve Sac Onarımı',
      summary: 'Hasarlı frigo dorse kasalarında poliüretan enjeksiyonu ve dış polyester sac yama adımları.',
      image: '/1.jpg',
      date: '13 Temmuz 2026',
      category: 'Kasa Tamiri'
    },
    {
      slug: 'frigo-dorse-kasa-tamiri-mersin-4',
      title: 'Dorse Kapı Tamiri ve Kasa Sızdırmazlık İşlemleri',
      summary: 'Mersin MIG tır parkı bölgesinde sunulan dorse kapı tamiri ve kasa paneli revizyon hizmetleri.',
      image: '/1.jpg',
      date: '12 Temmuz 2026',
      category: 'Kasa Tamiri'
    },
    {
      slug: 'frigo-dorse-kasa-tamiri-mersin-5',
      title: 'Soğutmalı Kasalarda Panel Yırtılması ve Poliüretan Tamiri',
      summary: 'Frigo tır dorselerinde sandviç panel hasarları, nem kurutma ve dolgu köpükleme teknikleri.',
      image: '/1.jpg',
      date: '11 Temmuz 2026',
      category: 'Kasa Tamiri'
    },
    {
      slug: 'frigo-dorse-kasa-tamiri-mersin-6',
      title: 'Frigo Dorse Kasa Revizyonu ve Hasar Onarım Aşamaları',
      summary: 'Soğutmalı dorselerde kapı menteşesi, kilit mekanizması ve sızdırmazlık lastiği değişimi.',
      image: '/1.jpg',
      date: '10 Temmuz 2026',
      category: 'Kasa Tamiri'
    },
    {
      slug: 'frigo-dorse-kasa-tamiri-mersin-7',
      title: 'Tır Kasa Paneli Onarımında Dikkat Edilmesi Gerekenler',
      summary: 'Dorse kasa polyester yırtıklarında su sızdırmazlığını sağlayan elyaf ve reçine uygulamaları.',
      image: '/1.jpg',
      date: '9 Temmuz 2026',
      category: 'Kasa Tamiri'
    },
    {
      slug: 'frigo-dorse-kasa-tamiri-mersin-8',
      title: 'Mersin Akdeniz Bölgesi Frigo Dorse Kasa Tamir Servisi',
      summary: 'Kaza sonrası frigo dorse kasa doğrultma, panel birleştirme ve boyama aşamaları.',
      image: '/1.jpg',
      date: '8 Temmuz 2026',
      category: 'Kasa Tamiri'
    },
    {
      slug: 'frigo-dorse-kasa-tamiri-mersin-9',
      title: 'Dorse Panel Kırılması ve Polyester Yama Uygulamaları',
      summary: 'Mersin\'de uzman kadromuzla gerçekleştirilen frigo dorse kasa yan duvar ve taban onarımı.',
      image: '/1.jpg',
      date: '7 Temmuz 2026',
      category: 'Kasa Tamiri'
    },
    {
      slug: 'frigo-dorse-kasa-tamiri-mersin-10',
      title: 'Frigo Dorse Kasalarında Arka Kapı ve Kilit Revizyonu',
      summary: 'Dorse kasa panellerinin yalıtım özelliğini korumaya yönelik lokal polyester yama teknikleri.',
      image: '/1.jpg',
      date: '6 Temmuz 2026',
      category: 'Kasa Tamiri'
    },
    {
      slug: 'tir-dorse-yedek-parca-secimi-1',
      title: 'Tır ve Dorse Yedek Parçalarında Kalite Standartları',
      summary: 'Mersin\'de tır ve frigo dorse yedek parça tedariği. Kasa kapı kilitleri, rüzgarlık, çamurluk, cıvata ve hırdavat malzemeleri.',
      image: '/42.png',
      date: '15 Temmuz 2026',
      category: 'Yedek Parça'
    },
    {
      slug: 'tir-dorse-yedek-parca-secimi-2',
      title: 'Mersin\'de Dorse Yedek Parça ve Aksesuar Seçimi',
      summary: 'Tır yedek parça Akdeniz ve dorse yedek parçaları Mersin stoklarımız hakkında teknik bilgilendirme.',
      image: '/42.png',
      date: '14 Temmuz 2026',
      category: 'Yedek Parça'
    },
    {
      slug: 'tir-dorse-yedek-parca-secimi-3',
      title: 'Frigo Kasa Kapı Kilitleri ve Menteşe Yedek Parçaları',
      summary: 'Frigo kasa kapı kilidi, menteşeler, kapı contaları ve dorse aksesuarları seçiminde kalite kriterleri.',
      image: '/42.png',
      date: '13 Temmuz 2026',
      category: 'Yedek Parça'
    },
    {
      slug: 'tir-dorse-yedek-parca-secimi-4',
      title: 'Ağır Vasıta Araçlarda Çamurluk ve Rüzgarlık Parçaları',
      summary: 'Tır ve dorse dış koruma elemanları çamurluk ve rüzgarlık montajında dikkat edilmesi gerekenler.',
      image: '/42.png',
      date: '12 Temmuz 2026',
      category: 'Yedek Parça'
    },
    {
      slug: 'tir-dorse-yedek-parca-secimi-5',
      title: 'Dorse Tamirinde Hırdavat ve Dayanıklı Cıvata Seçimi',
      summary: 'Dorse montaj işlemlerinde kullanılan yüksek dayanımlı cıvata, vida ve sızdırmazlık silikonları.',
      image: '/42.png',
      date: '11 Temmuz 2026',
      category: 'Yedek Parça'
    },
    {
      slug: 'tir-dorse-yedek-parca-secimi-6',
      title: 'Tır ve Dorse Plastik Aksamlarında Malzeme Kalitesi',
      summary: 'Mersin MIG tır parkı bölgesinde ağır vasıtalar için hızlı yedek parça temini ve stok bilgileri.',
      image: '/42.png',
      date: '10 Temmuz 2026',
      category: 'Yedek Parça'
    },
    {
      slug: 'tir-dorse-yedek-parca-secimi-7',
      title: 'Mersin Akdeniz Bölgesi Tır Dorse Yedek Parça Tedariği',
      summary: 'Frigo dorse kasalarının sızdırmazlığını koruyan orijinal uyumlu kapı lastikleri ve kilit takımları.',
      image: '/42.png',
      date: '9 Temmuz 2026',
      category: 'Yedek Parça'
    },
    {
      slug: 'tir-dorse-yedek-parca-secimi-8',
      title: 'Frigo Dorse Kapı Lastiği ve Sızdırmazlık Parçaları',
      summary: 'Dorse alüminyum kasa profilleri, tampon parçaları ve yan koruma bariyerleri yedek parçaları.',
      image: '/42.png',
      date: '8 Temmuz 2026',
      category: 'Yedek Parça'
    },
    {
      slug: 'tir-dorse-yedek-parca-secimi-9',
      title: 'Dorse Kasa Profilleri ve Dış Koruma Aksesuarları',
      summary: 'Ağır yol şartlarına dayanıklı tır plastik aksamları, rüzgarlık setleri ve çamurluk montajı.',
      image: '/42.png',
      date: '7 Temmuz 2026',
      category: 'Yedek Parça'
    },
    {
      slug: 'tir-dorse-yedek-parca-secimi-10',
      title: 'Ağır Vasıtalar İçin Orijinal Uyumlu Dorse Malzemeleri',
      summary: 'Dorse kasa tamirinde kullanılan kaliteli hırdavat grupları ve montaj yardımcı malzemeleri.',
      image: '/42.png',
      date: '6 Temmuz 2026',
      category: 'Yedek Parça'
    },
    {
      slug: 'mersin-frigo-dorse-servisi-rehberi-1',
      title: 'Mersin\'de Frigo Dorse Bakımı ve Servis Süreçleri',
      summary: 'Mersin MIG tır parkı dorse servisi, frigo kasa periyodik bakım süreçleri, araç yalıtımı ve kapı lastiği değişimi.',
      image: '/18.jpeg',
      date: '15 Temmuz 2026',
      category: 'Dorse Bakım'
    },
    {
      slug: 'mersin-frigo-dorse-servisi-rehberi-2',
      title: 'Mersin Lojistik Sektörü Frigo Dorse Servis Rehberi',
      summary: 'Mersin frigo dorse servisi ve MIG tır parkı dorse tamiri hizmetlerimiz hakkında detaylı bilgiler.',
      image: '/18.jpeg',
      date: '14 Temmuz 2026',
      category: 'Dorse Bakım'
    },
    {
      slug: 'mersin-frigo-dorse-servisi-rehberi-3',
      title: 'MIG Tır Parkında Dorse Tamir ve Periyodik Bakım',
      summary: 'Tır ve dorse araçlarında yolda kalmayı önleyen periyodik bakım adımları ve servis tavsiyeleri.',
      image: '/18.jpeg',
      date: '13 Temmuz 2026',
      category: 'Dorse Bakım'
    },
    {
      slug: 'mersin-frigo-dorse-servisi-rehberi-4',
      title: 'Tır Dorselerinde Periyodik Bakım ve Kasa İncelemesi',
      summary: 'Mersin Akdeniz dorse servis istasyonumuzda sunulan hızlı bakım ve arıza giderme işlemleri.',
      image: '/18.jpeg',
      date: '12 Temmuz 2026',
      category: 'Dorse Bakım'
    },
    {
      slug: 'mersin-frigo-dorse-servisi-rehberi-5',
      title: 'Mersin Akdeniz Bölgesinde Soğutmalı Dorse Servisi',
      summary: 'Frigo dorse kasalarında nem ve ısı yalıtım kaçaklarının tespiti ve periyodik servis süreçleri.',
      image: '/18.jpeg',
      date: '11 Temmuz 2026',
      category: 'Dorse Bakım'
    },
    {
      slug: 'mersin-frigo-dorse-servisi-rehberi-6',
      title: 'Lojistik Firmaları İçin Dorse Periyodik Bakım Adımları',
      summary: 'Uluslararası nakliye rotalarındaki tırlar için yol öncesi dorse kilit ve panel kontrolleri.',
      image: '/18.jpeg',
      date: '10 Temmuz 2026',
      category: 'Dorse Bakım'
    },
    {
      slug: 'mersin-frigo-dorse-servisi-rehberi-7',
      title: 'Mersin Liman Öncesi Dorse Kontrol ve Servis Hizmeti',
      summary: 'Mersin liman bölgesinde dorse kapı contası değişimi ve menteşe kilit revizyon çalışmaları.',
      image: '/18.jpeg',
      date: '9 Temmuz 2026',
      category: 'Dorse Bakım'
    },
    {
      slug: 'mersin-frigo-dorse-servisi-rehberi-8',
      title: 'Tır Dorselerinde Yol Öncesi Sızdırmazlık ve Kilit Kontrolü',
      summary: 'Soğutmalı dorselerde ısı kontrol üniteleri ve kasa yalıtım panellerinin periyodik bakımı.',
      image: '/18.jpeg',
      date: '8 Temmuz 2026',
      category: 'Dorse Bakım'
    },
    {
      slug: 'mersin-frigo-dorse-servisi-rehberi-9',
      title: 'Frigo Dorse Kasalarında Periyodik Yalıtım Kontrolü',
      summary: 'Mersin lojistik firmalarına yönelik toplu dorse periyodik bakım ve kontrol çözümleri.',
      image: '/18.jpeg',
      date: '7 Temmuz 2026',
      category: 'Dorse Bakım'
    },
    {
      slug: 'mersin-frigo-dorse-servisi-rehberi-10',
      title: 'Mersin\'de Profesyonel Dorse Bakım ve Revizyon Hizmetleri',
      summary: 'Ağır vasıta dorselerinde şasi doğrultma, kapı ayarı ve kasa sızdırmazlık testleri.',
      image: '/18.jpeg',
      date: '6 Temmuz 2026',
      category: 'Dorse Bakım'
    },

    {
      slug: 'frigo-dorse-isi-yalitimi',
      title: 'Frigo Dorse Kasalarında Isı Yalıtımı ve Poliüretan İzolasyon Teknikleri',
      summary: 'Frigo dorse kasalarında poliüretan köpük kaplama ve araç içi yalıtım tekniklerinin ısı kontrolü, enerji tasarrufu ve taşıma standartları üzerindeki rolü.',
      image: '/25.png',
      date: '15 Temmuz 2026',
      category: 'Araç İçi Yalıtım'
    },
    {
      slug: 'double-deck-dorse-tasima-kapasitesi',
      title: 'Çift Katlı Dorse (Double Deck) Sistemleri ile Taşıma Kapasitesi Nasıl Artırılır?',
      summary: 'Lojistikte verimliliği artırmak ve yükleme hacmini ikiye katlamak için uygulanan çift katlı dorse tadilat süreçleri ve double deck montaj detayları.',
      image: '/24.jpg',
      date: '12 Temmuz 2026',
      category: 'Double Deck'
    },
    {
      slug: 'frigo-dorse-kasa-tamiri-mersin',
      title: 'Frigo Dorse Kasa ve Panel Tamirinde Dikkat Edilmesi Gereken Teknik Detaylar',
      summary: 'Kaza veya yıpranma sonrası soğutmalı dorse kasalarında panel onarımı, polyester tamir süreçleri ve dorse kapı revizyon işlemlerinin aşamaları.',
      image: '/1.jpg',
      date: '10 Temmuz 2026',
      category: 'Kasa Tamiri'
    },
    {
      slug: 'tir-dorse-yedek-parca-secimi',
      title: 'Tır ve Dorse Yedek Parça Seçiminde Kalite ve Standart Kriterleri',
      summary: 'Aşınma ve yıpranmalara karşı çamurluk, rüzgarlık, kapı kilit sistemleri ve hırdavat malzemeleri seçiminde uzun vadeli dayanıklılık ipuçları.',
      image: '/42.png',
      date: '08 Temmuz 2026',
      category: 'Yedek Parça'
    },
    {
      slug: 'mersin-frigo-dorse-servisi-rehberi',
      title: 'Mersin Lojistik Sektöründe Frigo Dorse Bakım ve Servis İhtiyaçları',
      summary: 'Uluslararası taşımacılık rotalarındaki araçların MIG tır parkı dorse servisi süreçleri ve yolda kalmayı önleyen periyodik bakım tavsiyeleri.',
      image: '/18.jpeg',
      date: '05 Temmuz 2026',
      category: 'Dorse Bakım'
    }
  ];

  return (
    <Box sx={{ bgcolor: 'grey.50', py: 12, minHeight: '80vh' }}>
      <Container maxWidth="xl" sx={{ px: { xs: 2, md: 4, lg: 6 } }}>
        <Fade in timeout={800}>
          <Box textAlign="center" mb={8}>
            <Chip 
              label="Sektörel Paylaşımlar ve Teknik Bilgiler" 
              sx={{ 
                mb: 3, 
                bgcolor: 'primary.main', 
                color: 'white',
                fontSize: '0.9rem',
                fontWeight: 'bold',
                px: 2,
                py: 1
              }} 
            />
            <Typography variant="h2" component="h1" gutterBottom color="text.primary" sx={{ fontWeight: 'bold', mb: 3 }}>
              Kale Treyler Blog
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '600px', mx: 'auto' }}>
              Frigo dorse yalıtımı, çift katlı sistemler ve dorse tamir süreçlerine dair rehber içeriklerimizle arama motorlarındaki yerimizi güçlendiriyoruz.
            </Typography>
          </Box>
        </Fade>

        <Grid container spacing={4}>
          {posts.map((post, index) => (
            <Grid item xs={12} md={6} lg={4} key={post.slug}>
              <Fade in timeout={1000 + index * 100}>
                <Card
                  elevation={0}
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    border: '1px solid',
                    borderColor: 'grey.200',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                      borderColor: 'primary.main',
                    },
                  }}
                >
                  <Box sx={{ position: 'relative', width: '100%', pt: '56.25%', overflow: 'hidden' }}>
                    <LoadingImage
                      src={post.image}
                      alt={post.title}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  </Box>
                  <CardContent sx={{ flexGrow: 1, p: 4 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                      <Typography variant="caption" color="text.secondary">
                        {post.date}
                      </Typography>
                      <Chip 
                        label={post.category} 
                        size="small" 
                        color="secondary" 
                        sx={{ fontWeight: 'semibold', fontSize: '0.75rem' }} 
                      />
                    </Box>
                    <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 2, fontSize: '1.25rem', lineHeight: 1.4 }}>
                      {post.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                      {post.summary}
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ px: 4, pb: 4, pt: 0 }}>
                    <Button
                      component={RouterLink}
                      to={`/blog/${post.slug}`}
                      variant="outlined"
                      size="small"
                      color="primary"
                      fullWidth
                      sx={{
                        py: 1,
                        fontWeight: 'bold',
                        borderRadius: 2,
                        '&:hover': {
                          bgcolor: 'primary.main',
                          color: 'white',
                        }
                      }}
                    >
                      Devamını Oku
                    </Button>
                  </CardActions>
                </Card>
              </Fade>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default BlogList;
